import { type FC, type ReactElement } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import dibsCss from 'dibs-css';
import classnames from 'classnames';

type FollowSearchProps = {
    searchName: string;
    searchNameClassname?: string;
};

export const FollowSearch: FC<FollowSearchProps> = ({ searchName, searchNameClassname }) => (
    <FormattedMessage
        id="global.followSearch"
        defaultMessage="Follow {searchName} to receive alerts when new items arrive"
        values={{
            searchName: <span className={searchNameClassname || ''}>{searchName}</span>,
        }}
    />
);

export const moreDetails = (
    <FormattedMessage id="global.moreDetails" defaultMessage="More Details" />
);
export const seeLess = <FormattedMessage id="abf.global.seeLess.copy" defaultMessage="See Less" />;

export const viewSimilarItems = (
    <FormattedMessage id="global.viewSimilarItems" defaultMessage="View Similar Items" />
);

export const visuallySimilar = (
    <FormattedMessage id="global.visuallySimilar" defaultMessage="Visually Similar" />
);

export const moreFromThisSeller = (
    <FormattedMessage id="global.moreFromThisSeller" defaultMessage="More From This Seller" />
);

export const IncludesSponsoredLabel: FC<{ isVisible?: boolean }> = ({ isVisible }) => (
    <span
        className={classnames(
            dibsCss.sassyFontBodyXSmall,
            dibsCss.textSatan,
            !isVisible && dibsCss.invisible
        )}
    >
        <FormattedMessage id="global.includesSponsoredLabel" defaultMessage="Includes Sponsored" />
    </span>
);

type ItemsSimilarToHeaderProps = {
    title: ReactElement;
    isPdpTopYmalSponsoredTestVariant?: boolean;
    showSponsoredLabel?: boolean;
};

export const ItemsSimilarToHeader: FC<ItemsSimilarToHeaderProps> = ({
    title,
    isPdpTopYmalSponsoredTestVariant,
    showSponsoredLabel,
}) => (
    <>
        <FormattedMessage
            values={{ title }}
            id="global.itemsSimilarToHeader"
            defaultMessage="Items Similar to {title}"
        />
        {isPdpTopYmalSponsoredTestVariant && (
            <IncludesSponsoredLabel isVisible={showSponsoredLabel} />
        )}
    </>
);

export const viewAll = (
    <FormattedMessage id="pdp.PdpMobileDealerItems.view_all" defaultMessage="View All" />
);
export const startConversationMessage = (
    <FormattedMessage id="global.starConversation" defaultMessage="Ask the Seller" />
);

export const messageSeller = (
    <FormattedMessage id="global.messageSeller" defaultMessage="Message the Seller" />
);

export const itemStatus = <FormattedMessage id="global.itemStatus" defaultMessage="Item Status:" />;

export const sellerInformation = (
    <FormattedMessage id="global.sellerInformation" defaultMessage="Seller Information" />
);

export const buyerIncentives = (
    <FormattedMessage id="global.buyerIncentives" defaultMessage="The 1stDibs Promise" />
);

export const itemDetails = (
    <FormattedMessage id="global.itemDetails" defaultMessage="Item Details" />
);

export const moreItems = <FormattedMessage id="global.moreItems" defaultMessage="More Items" />;
export const shippingAndReturns = (
    <FormattedMessage id="global.shippingAndReturns" defaultMessage="Shipping & Returns" />
);
export const customization = (
    <FormattedMessage id="global.customization" defaultMessage="Customization" />
);
